export default __webpack_public_path__ + "static/media/Mark-3-Suit-04.8f57846c.jpg";